export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_15.db38c665.jpg";